export function localeForI18n(lng: string | undefined): string {
  switch ((lng || 'en').split('-')[0]) {
    case 'lt': return 'lt-LT';
    case 'fil': return 'fil-PH';
    case 'en':
    default: return 'en-US';
  }
}
